import  {Svgs} from "./app/assets/images/index";
import BadgeIcon from "@mui/icons-material/Badge";
import AssessmentIcon from '@mui/icons-material/Assessment';

const AdminNavigation = [
  {
    name: "Dashboard",
    icon: Svgs.dashboard,
    path:"/dashboard"
   
  },
  // {
  //   name: "Employees",
  //   icon: Svgs.employees,
  //   path:"/employees",    
  // },
  // {
  //   name: "Employees Request",
  //   icon: Svgs.employees,
  //   path:"/employee/request",    
  // },
  // {
  //   name: "Companies",
  //   icon: Svgs.company,
  //   path:"/companies",    
  // },
  {
    name: "Properties",
    icon: Svgs.property,
    path:"/properties",    
  },
  {
    name: "Agents",
    icon: Svgs.employees,
    path:"/agent/list",    
  },
  {
    name: "Agents Approval",
    icon: Svgs.employees,
    path:"/approved-agent/list",    
  },
  {
    name: "Investors",
    icon: Svgs.employees,
    path:"/investor/list",    
  },
  {
    name: "Bookings",
    icon: Svgs.jobRequest ,
    path:"/booking/list",    
  },
  // {
  //   name: "Bookings approved",
  //   icon: Svgs.jobRequest ,
  //   path:"/approved/list",    
  // },
  //  {
  //   name: "Listings requests",
  //   icon: Svgs.employees,
  //   path:"/request/list",    
  // },
  {
    name: "Listing requests",
    icon: Svgs.employees,
    path:"/approved-request/list",    
  },
  {
    name: "Closed Deals",
    icon: Svgs.property,
    path: "/closed-deals/list"
  },
  {
    name: "View Sheet",
    icon: Svgs.dashboard,
    path: "/property/view-sheet"
  },
  {
    name: "Agents Report",
    icon: Svgs.employees,
    path: "/agent/report"
  },
  {
    name: "Properties Report",
    icon: Svgs.property,
    path: "/property/report"
  },
  // {
  //   name: "Job Request",
  //   icon: Svgs.jobRequest,
  //   path:"/jobrequest",    
  // },
  // {
  //   name: "Job Applicants",
  //   icon: Svgs.jobRequest,
  //   path:"/job-applicant",    
  // },
  // {
  //   name: "Jobs",
  //   icon: Svgs.jobRequest,
  //   path:"/jobs",    
  // },
  // {
  //   name: "Jobs Report",
  //   icon: Svgs.jobRequest,
  //   path:"/job/report",    
  // },
  // {
  //   name: "Application",
  //   icon: <Equalizer />,
  //   subMenu: [
  //     {
  //       name: "Kanban",
  //       icon: <Circle />,
  //       path: "/kanban"
  //     },
  //     {
  //       name: "Wizard",
  //       icon: <Circle />,
  //       path: "/wizard"
  //     },
  //     {
  //       name: "Calendar",
  //       icon: <Circle />,
  //       path: "/calendar"
  //     },
  //   ]
  // },
  // {
  //   name: "Ecommerce",
  //   icon: <ShoppingCart />,
  //   subMenu: [
  //     {
  //       name: "Products",
  //       icon: <Circle />,
  //       path: "/products"
  //     },
  //     {
  //       name: "Others",
  //       icon: <Circle />,
  //       path: "/others"
  //     },
  //   ]
  // },
  // {
  //   name: "Authentication",
  //   icon: <Person />,
  //   subMenu: [
  //     {
  //       name: "Sign In",
  //       icon: <Circle />,
  //       path: "/signin"
  //     },
  //     {
  //       name: "Sign Up",
  //       icon: <Circle />,
  //       path: "/signup"
  //     },
  //   ]
  // },
];
const PublicNavigation = [
  {
    name: "Home",
    icon: Svgs.dashboard,
    path:"/investor/dashboard"
   
  },
  {
    name: "Properties",
    icon: Svgs.property,
    path:"/investor/properties"
   
  },

  
 
];

export  {AdminNavigation,PublicNavigation};